import React, { useState, useEffect } from 'react';
import FooterPC from './FooterPC';
import FooterMobile from './FooterMobile';

const Footer: React.FC = () => {
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

    const handleWindowSizeChange = () => {
        setIsMobile(window.innerWidth <= 768);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    console.log('Is Mobile:', isMobile);

    return (
        <div>
            {isMobile ? (
                <FooterMobile />
            ) : (
                <FooterPC />
            )}
        </div>
    );
};

export default Footer;
